export default __webpack_public_path__ + "static/media/template1.2f63a979.png";